import { useEffect, useState } from "react";
import { Box } from "@mui/material";

import ToolBar from "./ToolBar";
import DialogCSVSettings from "./DialogCSVSettings";
import GridView from "./ContentViews/Grid";
import UploadFileView from "./ContentViews/UploadFile";
import LoadingView from "./ContentViews/Loading";
import { insertFile } from "../../../utils/Files";
import {
  getAll as getAllFiles,
  destroy as deleteById,
} from "../../../data/Files";
import FileTabBar from "../../Tabs/FileTabBar";
import FileTab from "../../Tabs/FileTab";

export default function Index(props) {
  let [registerFields, setRegisterFields] = useState([]);
  let [registerHeaders, setRegisterHeaders] = useState([]);
  let [screenHeight, setScreenHeight] = useState(window.innerHeight);
  let [files, setFiles] = useState([]);
  let [fileId, setFileId] = useState(0);
  let [fileName, setFileName] = useState(0);
  let [fileContent, setFileContent] = useState("");
  let [loading, setLoading] = useState(true);
  let [dialogCSVSettingsOpen, setDialogCSVSettingsOpen] = useState(false);

  useEffect(() => {
    listAllFiles();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize, false);
  }, []);

  const handleResize = () => {
    setScreenHeight(window.innerHeight);
  };

  const getCsvSettings = async (fileId) => {
    return new Promise((resolve) => {
      resolve({
        separator: localStorage.getItem("CSVSeparator" + fileId),
        removeQuotes:
          localStorage.getItem("CSVRemoveQuotes" + fileId) === "true"
            ? true
            : false,
        firstLineAsColumnName:
          localStorage.getItem("CSVFirstLineAsColumnName" + fileId) === "true"
            ? true
            : false,
      });
    });
  };

  const listAllFiles = async () => {
    let files = await getAllFiles();
    setFiles(files);
  };

  let handleUploadFile = async (e) => {
    const filename = e.target.files[0].name;
    e.preventDefault();
    const reader = new FileReader();
    reader.onload = async (e) => {
      const text = e.target.result;
      await insertFile(props.layoutId, filename, text);
      listAllFiles();
    };
    reader.readAsText(e.target.files[0]);
  };

  const handleClickAddFile = async () => {
    setFileId(0);
    localStorage.setItem("lastClickedFileForLayoutId" + props.layoutId, 0);
  };

  const handleLoadFile = async (fileId, fileContent, fileName) => {
    setLoading(true);
    setFileId(fileId);
    setFileName(fileName);
    setFileContent(fileContent);

    localStorage.setItem("lastClickedLayout", props.layoutId);
    localStorage.setItem("lastClickedFileForLayoutId" + props.layoutId, fileId);
    let csvSettings = await getCsvSettings(fileId);

    if (!csvSettings.separator) {
      localStorage.setItem(
        "CSVSeparator" + fileId,
        localStorage.getItem("CSVSeparator"),
      );
      localStorage.setItem(
        "CSVFirstLineAsColumnName" + fileId,
        localStorage.getItem("CSVFirstLineAsColumnName"),
      );
      localStorage.setItem(
        "CSVRemoveQuotes" + fileId,
        localStorage.getItem("CSVRemoveQuotes"),
      );
      csvSettings = await getCsvSettings(fileId);
    }

    await generateFields(fileContent, csvSettings);
    await generateRegisterHeaders(fileContent, csvSettings);

    setLoading(false);
  };

  const handleDeleteFile = async (fileId) => {
    await deleteById(fileId);
    localStorage.removeItem("CSVSeparator" + fileId);
    localStorage.removeItem("CSVFirstLineAsColumnName" + fileId);
    localStorage.removeItem("CSVRemoveQuotes" + fileId);

    setFileId(0);
    listAllFiles();
  };

  const generateFields = async (fileContent, csvSettings) => {
    setRegisterFields([]);
    let registerFields = [];
    let lineNumber = 0;

    await Promise.all(
      fileContent.split("\n").map(function (line) {
        let colNumber = 0;
        let fields = { id: lineNumber, line: lineNumber };

        //para evitar uma verificação a cada item do map, gerando uma leitura mais lenta, o codigo inteiro do map foi gerado dentro do retorno de cada if
        if (csvSettings.removeQuotes) {
          line.split(csvSettings.separator).map((item) => {
            fields["_" + colNumber] = removeQuotes(item);

            colNumber++;
          });
        } else {
          line.split(csvSettings.separator).map((item) => {
            fields["_" + colNumber] = item;

            colNumber++;
          });
        }

        if (!(lineNumber === 0 && csvSettings.firstLineAsColumnName))
          registerFields = registerFields.concat(fields);
        lineNumber++;
      }),
    );
    console.log(registerFields);
    setRegisterFields(registerFields);
  };

  const generateRegisterHeaders = async (fileContent, csvSettings) => {
    setRegisterHeaders([]);
    let columns = [
      {
        field: "line",
        headerName: "Linha",
        type: "number",
        minWidth: 70,
      },
    ];
    const firstLine = fileContent.split("\n").shift();
    let colNumber = 0;
    await Promise.all(
      firstLine &&
        firstLine.split(csvSettings.separator).map((item) => {
          let minWidth = item.length * 11;

          columns = columns.concat({
            field: "_" + colNumber,
            headerName: csvSettings.firstLineAsColumnName
              ? item
              : "Col. " + colNumber,
            type: "string",
            minWidth: minWidth,
          });

          colNumber++;
        }),
    );
    setRegisterHeaders(columns);
  };

  const removeQuotes = (str) => {
    if (str.startsWith('"') && str.endsWith('"')) {
      return str.slice(1, -1);
    } else {
      return str;
    }
  };

  const handleToggleCSVSettings = () => {
    setDialogCSVSettingsOpen(!dialogCSVSettingsOpen);
  };

  return (
    <div
      component="main"
      style={{
        flexGrow: 1,
        overflow: "hidden",
      }}
      mt={4}
    >
      <DialogCSVSettings
        open={dialogCSVSettingsOpen}
        handleToggleCSVSettings={handleToggleCSVSettings}
        fileId={fileId}
        fileName={fileName}
        handleLoadFile={handleLoadFile}
        fileContent={fileContent}
      />
      <Box
        sx={{
          bgcolor: "background.default",
          color: "text.primary",
        }}
      >
        <Box
          sx={{
            marginTop: "40px",
            padding: 1,
            userSelect: "none",
          }}
        >
          <FileTabBar
            handleClickAddFile={handleClickAddFile}
            enableAddFileButton={fileId === 0}
          >
            {files &&
              files.map((item) => {
                return (
                  props.layoutId === item["layoutId"] && (
                    <>
                      <FileTab
                        item={item}
                        handleDeleteFile={handleDeleteFile}
                        selected={fileId === item.id}
                        handleAction={() =>
                          handleLoadFile(
                            item.id,
                            item.fileContent,
                            item.fileName,
                          )
                        }
                        /*    handleLoadFile={handleLoadFile} */
                      />
                    </>
                  )
                );
              })}
          </FileTabBar>

          <ToolBar
            handleToggleCSVSettings={handleToggleCSVSettings}
            showViwModeButtons={
              fileId > 0 &&
              props.layoutId ===
                parseInt(localStorage.getItem("lastClickedLayout"))
            }
          ></ToolBar>
        </Box>

        {loading && fileId !== 0 && <LoadingView />}

        {fileId > 0 &&
          !loading &&
          props.layoutId ===
            parseInt(localStorage.getItem("lastClickedLayout")) && (
            <>
              <GridView
                screenHeight={screenHeight}
                rows={registerFields}
                columns={registerHeaders}
              />
            </>
          )}
        {(fileId === 0 ||
          props.layoutId !==
            parseInt(localStorage.getItem("lastClickedLayout"))) && (
          <UploadFileView handleUploadFile={handleUploadFile} />
        )}
      </Box>
    </div>
  );
}
